<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <label for="form-organization-address" class="col-form-label">{{ inputLabel }}</label>
    <typeahead
      v-model="inputValue"
      type="text"
      id="form-organization-address"
      autocomplete="off"
      :disabled="disabled"
      :data="data"
      :serializer="this.serializeData"
      :maxMatches="typeaheadLimit"
      @change="emit"
      @blur="emit"
      @keyup.enter="emit"
      @keyup.delete="emit"
      @hit="selectTypeahead($event, true)"
    >
<!--      <template v-slot:suggestion="{data}">-->
<!--        <template v-if="data && data.value">-->
<!--          <div>{{ data.value }}</div>-->
<!--        </template>-->
<!--      </template>-->
    </typeahead>
    <a v-if="!isCheck && showPrevValue"
       @click="revertAddress"
       class="organization-address-helpers">
      {{ prevValue }}
    </a>
    <span v-if="isCheck && showPrevValue"
          class="organization-address-helpers not-link">
      {{ prevValue }}
    </span>
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import organizationSectionMixin from '../../../../mixins/application-form/organizationSectionMixin'
import organizationInputMixin from '../../../../mixins/application-form/organizationInputMixin'

export default {
  name: 'OrganizationAddressInput',
  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    organizationSectionMixin,
    organizationInputMixin
  ],

  props: {
    inputLabel: {
      default: 'Адрес'
    },

    inputName: {
      default: 'address'
    },

    prevValue: {
      default: null
    }
  },

  data () {
    return {
      data: []
    }
  },

  computed: {
    showPrevValue () {
      return this.prevValue && this.prevValue !== this.inputValue
    }
  },

  methods: {
    revertAddress () {
      this.$emit('input', this.prevValue)
    },

    serializeData (item) {
      return item.unrestricted_value
    },

    checkInn (item) {
      return item?.value && item?.value?.indexOf(this.inputValue) !== -1
    }
  }
}
</script>
